import { render, staticRenderFns } from "./DropdownLoader.vue?vue&type=template&id=1e89f457"
import script from "./DropdownLoader.vue?vue&type=script&lang=js"
export * from "./DropdownLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports